<template>
  <div class="container">
    <tab-content-layout :title="title">
      <div v-if="items.length == 0" class="col-12 v-clean p-5">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>

      <div v-if="items.length > 0" class="my-2 text-right dont-show-on-print">
        <v-btn @click="handlePrint" class="btn-modern btn-modern-info"
          ><i class="fas fa-print"></i> IMPRIMIR</v-btn
        >
      </div>

      <v-data-table
        v-if="items.length > 0"
        :headers="headers"
        :items="items"
        dense
        :server-items-length="count"
        :options.sync="options"
        :footer-props="{
          'items-per-page-options': [1000],
          'items-per-page-text': 'Mostrar',
        }"
        :loading="loading"
        loading-text="Carregando..."
        no-data-text="Nenhum resultado corresponde aos filtros"
        no-results-text="Nenhum resultado corresponde aos filtros"
      >
        <template v-slot:[`item.entity`]="{ item }">
          <div v-if="item.nfeId">
            <strong class="text-uppercase">{{ item.nfeId }}</strong>
          </div>
          <div v-if="item.entity" class="row">
            <div
              v-for="k in Object.keys(item.entity)"
              :key="k"
              class="col-md-6 pt-0 pb-0 border-bottom"
            >
              <small>{{ item.fields[k] }}:</small>
              <small
                ><strong class="ml-2">{{ item.entity[k] }}</strong></small
              >
            </div>
          </div>
          <div class="border-top" v-if="item.items">
            <div v-for="(i, key) in item.items" :key="key">
              <div class="row m-0 border-bottom">
                <div class="col-md-4 p-0">
                  <p class="m-0">
                    <span class="text-muted">Item:</span
                    ><span class="ml-2">{{ i.name }}</span>
                  </p>
                </div>
                <div class="col-md-4 p-0">
                  <p class="m-0">
                    <span class="text-muted">Quantidade:</span>
                    {{ i.amount }}
                    {{ i.abbreviation ? i.abbreviation : "" }}
                  </p>
                </div>
                <div class="col-md-4 p-0">
                  <p class="m-0">
                    <span class="text-muted">Valor:</span>
                    {{ formatReal(i.value) }}
                  </p>
                </div>
                <div class="col-md-4 p-0">
                  <p class="m-0">
                    <span class="text-muted">Lote:</span>
                    {{ i.lot ? i.lot : "NÃO INFORMADO" }}
                  </p>
                </div>
                <div class="col-md-4 p-0">
                  <p class="m-0">
                    <span class="text-muted">Descrição:</span>
                    {{ i.description ? i.description : "NÃO INFORMADO" }}
                  </p>
                </div>
                <div class="col-md-4 p-0">
                  <p class="m-0">
                    <span class="text-muted">Vencimento:</span>
                    {{ i.due_date ? i.due_date : "NÃO INFORMADO" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:[`item.user_id`]="{ item }">
          <small>{{
            professionalClassCouncilValue(getUserById(item.user_id))
          }}</small>
        </template>
        <template v-slot:[`item.date_time`]="{ item }">
          <small>
            {{ item.when ? formatDate(item.when) : item.date_time }}
          </small>
        </template>
      </v-data-table>

      <div v-if="items.length > 0" class="my-2 text-right dont-show-on-print">
        <v-btn @click="handlePrint" class="btn-modern btn-modern-info"
          ><i class="fas fa-print"></i> IMPRIMIR</v-btn
        >
      </div>

      <errors-messages :errors="errors" />
    </tab-content-layout>
  </div>
</template>

<script>
import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";

import TabContentLayout from "../templates/Components/TabContentLayout.vue";

import {
  formatDate,
  formatTime,
  formatReal,
  professionalClassCouncilValue,
} from "../lib/format";

import api from "../services/api";

export default {
  name: "StockHistoryPrint",

  components: {
    TabContentLayout,
    ErrorsMessages,
  },

  data() {
    return {
      headers: [
        { text: "Informações", value: "entity", sortable: false },
        { text: "Responsável", value: "user_id", sortable: false },
        { text: "Ocorrência", value: "date_time", sortable: false },
      ],

      title: "Histórico de estoque",

      users: [],
      items: [],

      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ["date_time"],
        sortDesc: [true],
        multiSort: true,
        mustSort: false,
      },

      count: 0,

      errors: [],
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,
    formatTime,
    formatReal,
    professionalClassCouncilValue,

    getUserById(id) {
      for (let user of this.users) {
        if (user.id == id) {
          return {
            id: user.professional_class_council_id,
            name: user.name,
            value: user.professional_class_council_value,
            cpf: user.cpf,
            office: user.office,
          };
        }
      }

      return {
        id: null,
        name: "DEMO",
        value: null,
        cpf: null,
        office: null,
      };
    },

    async retrieve() {
      await this.getUsers();
      await this.paginate(this.$route.query);
    },

    async getUsers() {
      try {
        this.loading = true;

        let response = await api.get("/rest-home/users");

        let { error, errors, users } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.users = [{ id: "", name: "TODOS" }, ...users];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async paginate(params) {
      try {
        if (params.view == "entry") {
          this.title = "Histórico de entrada";
        } else if (params.view == "output") {
          this.title = "Histórico de saída";
        } else if (params.view == "purchase") {
          this.title = "Histórico de compra";
        } else if (params.view == "transfer") {
          this.title = "Histórico de transferência";
        } else if (params.view == "reversal") {
          this.title = "Histórico de estorno";
        } else if (params.view == "reversal-purchase") {
          this.title = "Histórico de estorno de compra";
        }

        params.items_per_page = 1000;

        this.loading = true;

        let response = null;
        if (["entry", "output", "reversal", "transfer"].includes(params.view)) {
          response = await api.get("/rest-home/stock/history", { params });
        } else if (["purchase"].includes(params.view)) {
          response = await api.get("/rest-home/stock/history-purchase", {
            params,
          });
        } else if (["reversal-purchase"].includes(params.view)) {
          response = await api.get("/rest-home/history/reversal/purchase", {
            params,
          });
        }

        if (response) {
          let { error, errors, items, count } = response.data;

          if (error) {
            this.items = [];
            this.count = 0;
            this.errors = errors;
          } else {
            this.errors = [];
            this.items = items;
            this.count = count;
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handlePrint() {
      window.print();
    },
  },
};
</script>

<style>
@media print {
  .dont-show-on-print {
    display: none;
  }
}
</style>